import { render, staticRenderFns } from "./SelectionListDetails.vue?vue&type=template&id=383e7c55&scoped=true&"
import script from "./SelectionListDetails.vue?vue&type=script&lang=js&"
export * from "./SelectionListDetails.vue?vue&type=script&lang=js&"
import style0 from "./SelectionListDetails.vue?vue&type=style&index=0&id=383e7c55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e7c55",
  null
  
)

export default component.exports